function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M582.615 393.105L581.985 394.535L540.868 132.24C539.317 122.315 528.071 114.39 515.747 114.39H381.091C368.755 114.39 358.794 122.315 358.83 132.24L359.836 394.996L359.012 393.542L359.994 405.805L360.006 405.793C361.363 419.874 373.542 431.108 388.338 431.108H559.36C574.386 431.108 584.856 419.523 583.572 405.139L583.584 405.151L582.615 393.105Z",
  fill: "#105FB4"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M558.342 418.444H387.32C371.664 418.444 358.915 405.854 358.855 390.621L357.813 119.576C357.776 109.652 367.737 101.726 380.073 101.726H514.73C527.066 101.726 538.299 109.652 539.85 119.576L582.336 390.621C584.736 405.854 574.011 418.444 558.342 418.444Z",
  fill: "#A0F2FE"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M556.087 413.876H388.845C374.849 413.876 363.434 402.655 363.337 389.046L361.483 120.619C361.422 111.7 370.353 104.574 381.429 104.574H513.831C524.907 104.574 534.989 111.7 536.359 120.619L577.609 389.046C579.693 402.655 570.071 413.876 556.087 413.876Z",
  fill: "url(#paint0_radial_233_16300)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M556.087 413.876H388.845C374.849 413.876 363.434 402.655 363.337 389.046L361.483 120.619C361.422 111.7 370.353 104.574 381.429 104.574H513.831C524.907 104.574 534.989 111.7 536.359 120.619L577.609 389.046C579.693 402.655 570.071 413.876 556.087 413.876Z",
  fill: "#54A3F8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M566.557 317.149L536.359 120.619C534.989 111.7 524.907 104.574 513.831 104.574H381.429C370.353 104.574 361.422 111.7 361.483 120.619L361.519 125.49C416.075 196.999 485.451 256.232 566.557 317.149Z",
  fill: "#482BB8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M461.096 112.039H435.369C434.581 112.039 433.903 111.53 433.854 110.9C433.806 110.269 434.412 109.76 435.211 109.76H460.878C461.665 109.76 462.356 110.269 462.417 110.9C462.477 111.53 461.883 112.039 461.096 112.039Z",
  fill: "#340D58"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M480.956 426.781H466.05C465.214 426.781 464.233 426.078 463.845 425.169C463.433 424.188 463.845 423.34 464.79 423.34H481.659C482.604 423.34 483.161 424.188 482.907 425.169C482.664 426.09 481.792 426.781 480.956 426.781Z",
  fill: "#324DB5"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M42.9212 393.105L43.5514 394.535L84.668 132.24C86.2191 122.315 97.4647 114.39 109.789 114.39H244.445C256.781 114.39 266.742 122.315 266.706 132.24L265.7 394.996L266.524 393.542L265.542 405.805L265.53 405.793C264.173 419.874 251.994 431.108 237.198 431.108H66.1758C51.1494 431.108 40.6794 419.523 41.9639 405.139L41.9518 405.151L42.9212 393.105Z",
  fill: "#267FE0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M67.1954 418.444H238.218C253.874 418.444 266.623 405.854 266.683 390.621L267.725 119.576C267.762 109.652 257.801 101.726 245.464 101.726H110.808C98.4721 101.726 87.2387 109.652 85.6875 119.576L43.2016 390.609C40.8143 405.854 51.5388 418.444 67.1954 418.444Z",
  fill: "#A0F2FE"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M69.4608 413.876H236.702C250.699 413.876 262.114 402.655 262.211 389.046L264.065 120.619C264.126 111.7 255.195 104.574 244.119 104.574H111.704C100.629 104.574 90.5463 111.7 89.1769 120.619L47.9391 389.046C45.8427 402.655 55.4645 413.876 69.4608 413.876Z",
  fill: "url(#paint1_radial_233_16300)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M69.4608 413.876H236.702C250.699 413.876 262.114 402.655 262.211 389.046L264.065 120.619C264.126 111.7 255.195 104.574 244.119 104.574H111.704C100.629 104.574 90.5463 111.7 89.1769 120.619L47.9391 389.046C45.8427 402.655 55.4645 413.876 69.4608 413.876Z",
  fill: "url(#paint2_radial_233_16300)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M58.9766 317.149L89.1748 120.619C90.5441 111.7 100.626 104.574 111.702 104.574H244.104C255.18 104.574 264.111 111.7 264.051 120.619L264.014 125.49C209.459 196.999 140.095 256.232 58.9766 317.149Z",
  fill: "#54A3F8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M164.452 112.039H190.179C190.967 112.039 191.645 111.53 191.694 110.9C191.742 110.269 191.136 109.76 190.337 109.76H164.658C163.871 109.76 163.18 110.269 163.119 110.9C163.059 111.53 163.653 112.039 164.452 112.039Z",
  fill: "#340D58"
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M144.581 426.781H159.486C160.322 426.781 161.304 426.079 161.692 425.17C162.104 424.188 161.692 423.34 160.746 423.34H143.878C142.933 423.34 142.375 424.188 142.63 425.17C142.884 426.091 143.745 426.781 144.581 426.781Z",
  fill: "#324DB5"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M266.85 186.019C258.622 192.866 250.6 200.864 243.002 209.88L268.22 224.53C275.818 215.514 283.84 207.517 292.068 200.67L266.85 186.019Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M282.641 174.447C279.684 176.325 276.739 178.361 273.807 180.542L299.024 195.193C301.957 193.011 304.902 190.976 307.858 189.097L282.641 174.447Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M298.565 165.831C295.621 167.139 292.664 168.618 289.707 170.242L298.602 175.404C301.559 173.768 304.515 172.302 307.46 170.993L298.565 165.831Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M313.942 174.774C310.998 176.082 308.041 177.561 305.084 179.185L417.37 244.416C420.327 242.78 423.284 241.314 426.228 240.005L313.942 174.774Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M314.233 160.402C311.373 161.104 308.477 161.977 305.557 163.019L314.451 168.181C317.372 167.139 320.268 166.267 323.128 165.564L314.233 160.402Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M329.624 169.333C326.764 170.035 323.868 170.908 320.947 171.95L369.516 200.149C372.437 199.107 375.333 198.234 378.193 197.531L329.624 169.333Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M385.087 201.555C382.227 202.258 379.331 203.13 376.41 204.172L433.232 237.194C436.152 236.152 439.048 235.279 441.908 234.576L385.087 201.555Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M329.334 158.354C326.608 158.402 323.833 158.645 321.021 159.069L329.916 164.231C332.728 163.807 335.503 163.577 338.229 163.516L329.334 158.354Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M442.346 215.272C439.619 215.587 436.953 215.757 434.348 215.769L443.242 220.931C445.848 220.919 448.514 220.761 451.24 220.434L442.346 215.272Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M425.832 205.675C423.105 205.99 420.439 206.16 417.834 206.172L426.717 211.334C429.322 211.322 431.988 211.164 434.714 210.837L425.832 205.675Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M359.033 166.873C356.307 167.188 353.641 167.357 351.035 167.369L410.196 201.736C412.801 201.724 415.467 201.567 418.194 201.239L359.033 166.873Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M374.194 163.637C371.298 164.522 368.438 165.249 365.639 165.818L379.441 173.84C382.24 173.271 385.1 172.544 387.997 171.659L374.194 163.637Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M396.891 176.822C393.995 177.706 391.135 178.433 388.336 179.003L424.799 200.173C427.598 199.604 430.458 198.877 433.355 197.992L396.891 176.822Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M343.656 157.941C340.93 158.256 338.264 158.426 335.658 158.438L344.553 163.601C347.158 163.588 349.824 163.431 352.551 163.104L343.656 157.941Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M358.815 154.694C355.919 155.578 353.059 156.306 350.26 156.875L359.154 162.037C361.954 161.468 364.814 160.741 367.71 159.856L358.815 154.694Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M374.848 148.332C371.807 149.81 368.789 151.119 365.82 152.27L374.715 157.433C377.684 156.281 380.701 154.973 383.743 153.494L374.848 148.332Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M391.44 138.819C388.834 140.54 386.193 142.176 383.539 143.715C383.09 143.982 382.642 144.236 382.182 144.491L391.076 149.653C391.525 149.398 391.973 149.144 392.434 148.877C395.087 147.338 397.729 145.715 400.334 143.982L391.44 138.819Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M407.482 126.798C404.586 129.234 401.629 131.56 398.648 133.778L407.543 138.94C410.536 136.735 413.481 134.396 416.377 131.96L407.482 126.798Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M422.665 112.632C419.939 115.431 417.164 118.146 414.328 120.763L423.223 125.926C426.058 123.32 428.833 120.606 431.56 117.794L422.665 112.632Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M440.989 202.427C438.093 203.312 435.233 204.039 432.434 204.608L441.316 209.771C444.115 209.201 446.975 208.474 449.871 207.589L440.989 202.427Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M457.022 196.065C453.98 197.543 450.963 198.852 447.994 200.003L456.877 205.166C459.846 204.014 462.863 202.706 465.905 201.227L457.022 196.065Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M450.95 173.404C448.344 175.125 445.702 176.761 443.049 178.3C442.6 178.567 442.152 178.821 441.691 179.076L473.235 197.386C473.683 197.131 474.131 196.877 474.592 196.61C477.246 195.071 479.888 193.448 482.493 191.715L450.95 173.404Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M467.006 161.383C464.11 163.819 461.153 166.145 458.172 168.363L489.715 186.673C492.708 184.468 495.653 182.129 498.549 179.693L467.006 161.383Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M504.837 160.377C502.111 163.176 499.336 165.891 496.5 168.508L505.383 173.671C508.218 171.065 510.993 168.351 513.72 165.54L504.837 160.377Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M457.507 212.037C454.61 212.921 451.75 213.648 448.951 214.218L457.846 219.38C460.645 218.811 463.505 218.084 466.401 217.199L457.507 212.037Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M473.549 205.663C470.508 207.141 467.49 208.45 464.521 209.601L473.416 214.763C476.385 213.612 479.402 212.303 482.444 210.825L473.549 205.663Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M490.141 196.162C487.536 197.883 484.894 199.519 482.24 201.058C481.792 201.312 481.343 201.579 480.883 201.833L489.777 206.996C490.226 206.741 490.674 206.487 491.135 206.22C493.789 204.681 496.43 203.057 499.036 201.324L490.141 196.162Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M506.184 184.129C503.287 186.565 500.331 188.891 497.35 191.109L506.244 196.271C509.237 194.066 512.182 191.727 515.078 189.291L506.184 184.129Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M521.367 169.975C518.64 172.774 515.865 175.488 513.029 178.106L521.924 183.268C524.76 180.663 527.535 177.948 530.261 175.137L521.367 169.975Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M520.934 142.297C519.395 144.018 517.868 145.775 516.365 147.581C515.25 148.914 514.123 150.235 512.984 151.531L521.867 156.694C523.006 155.397 524.133 154.076 525.248 152.743C526.751 150.938 528.277 149.18 529.816 147.46L520.934 142.297Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M537.446 151.907C535.907 153.628 534.38 155.385 532.877 157.19C531.762 158.523 530.635 159.844 529.496 161.141L538.391 166.303C539.53 165.006 540.657 163.686 541.772 162.353C543.274 160.547 544.801 158.79 546.34 157.069L537.446 151.907Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M390.225 157.263C387.184 158.741 384.166 160.05 381.197 161.201L390.092 166.363C393.061 165.212 396.078 163.903 399.12 162.425L390.225 157.263Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M406.065 166.473C403.023 167.951 400.006 169.26 397.037 170.411L440.359 195.568C443.328 194.417 446.346 193.108 449.387 191.63L406.065 166.473Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M422.655 156.96C420.049 158.681 417.408 160.317 414.754 161.856C414.305 162.122 413.857 162.377 413.396 162.631L434.058 174.64C434.506 174.386 434.955 174.131 435.415 173.865C438.069 172.326 440.711 170.702 443.316 168.969L422.655 156.96Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M438.697 144.939C435.801 147.374 432.844 149.701 429.863 151.919L450.525 163.928C453.518 161.722 456.462 159.383 459.359 156.948L438.697 144.939Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M453.882 130.773C451.156 133.572 448.381 136.286 445.545 138.904L488.867 164.061C491.703 161.456 494.478 158.741 497.204 155.93L453.882 130.773Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M469.963 112.705C468.424 114.425 466.897 116.182 465.395 117.988C464.28 119.321 463.153 120.642 462.014 121.939L505.336 147.096C506.475 145.799 507.602 144.478 508.717 143.145C510.219 141.34 511.746 139.582 513.285 137.862L469.963 112.705Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M438.746 94.564C437.207 96.2847 435.68 98.0419 434.178 99.8474C433.063 101.18 431.936 102.501 430.797 103.798L455.069 117.903C456.208 116.607 457.335 115.286 458.45 113.953C459.953 112.147 461.48 110.39 463.019 108.669L438.746 94.564Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M406.815 147.762C404.209 149.483 401.568 151.119 398.914 152.658C398.465 152.913 398.017 153.179 397.557 153.434L406.451 158.596C406.9 158.342 407.348 158.087 407.809 157.82C410.462 156.281 413.104 154.658 415.709 152.925L406.815 147.762Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M422.861 135.729C419.965 138.165 417.008 140.491 414.027 142.709L422.922 147.871C425.915 145.666 428.86 143.327 431.756 140.891L422.861 135.729Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M438.044 121.575C435.318 124.374 432.543 127.089 429.707 129.706L438.602 134.869C441.437 132.263 444.212 129.549 446.939 126.737L438.044 121.575Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M344.709 167.285C341.983 167.333 339.208 167.575 336.396 168L412.074 211.964C414.885 211.54 417.66 211.31 420.387 211.249L344.709 167.285Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M428.034 215.684C425.307 215.733 422.532 215.975 419.721 216.399L448.683 233.231C451.494 232.807 454.269 232.577 456.996 232.516L428.034 215.684Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M457.892 224.3C455.166 224.615 452.5 224.785 449.895 224.797L463.321 232.601C465.927 232.589 468.593 232.431 471.319 232.104L457.892 224.3Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M473.042 221.065C470.145 221.949 467.286 222.676 464.486 223.246L477.913 231.05C480.712 230.48 483.572 229.753 486.469 228.869L473.042 221.065Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M489.085 214.691C486.043 216.169 483.026 217.478 480.057 218.629L493.483 226.433C496.452 225.282 499.47 223.973 502.511 222.495L489.085 214.691Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M505.676 205.19C503.071 206.91 500.429 208.546 497.775 210.085C497.327 210.352 496.878 210.606 496.418 210.861L509.845 218.665C510.293 218.411 510.742 218.156 511.202 217.889C513.856 216.35 516.498 214.727 519.103 212.994L505.676 205.19Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M521.721 193.157C518.812 195.592 515.868 197.919 512.887 200.137L526.314 207.941C529.307 205.735 532.251 203.397 535.148 200.961L521.721 193.157Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M536.902 179.003C534.175 181.802 531.4 184.517 528.564 187.134L541.991 194.938C544.827 192.333 547.602 189.618 550.329 186.807L536.902 179.003Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M552.983 160.935C551.444 162.655 549.917 164.412 548.414 166.218C547.299 167.551 546.172 168.872 545.033 170.169L558.46 177.973C559.599 176.676 560.726 175.355 561.841 174.022C563.344 172.216 564.87 170.459 566.409 168.739L552.983 160.935Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M537.946 125.465C535.061 127.974 532.214 130.615 529.402 133.39L574.894 159.82C577.705 157.045 580.565 154.391 583.437 151.895L537.946 125.465Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M455.762 77.7319C452.878 80.2404 450.03 82.8821 447.219 85.6571L521.757 128.955C524.568 126.18 527.428 123.526 530.3 121.03L455.762 77.7319Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M314.877 193.169C311.92 195.047 308.976 197.083 306.043 199.264L348.153 223.718C351.086 221.537 354.031 219.501 356.987 217.623L314.877 193.169Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M364.027 221.719C361.071 223.597 358.126 225.633 355.193 227.814L374.655 239.121C377.588 236.939 380.532 234.903 383.489 233.025L364.027 221.719Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M390.846 237.303C377.164 246.016 363.604 258.025 351.195 272.736L370.657 284.042C383.066 269.331 396.614 257.322 410.307 248.609L390.846 237.303Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M299.089 204.754C290.86 211.6 282.838 219.598 275.24 228.614L343.853 268.47C351.451 259.455 359.473 251.457 367.701 244.61L299.089 204.754Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M573.611 115.504C568.691 118.34 563.771 121.612 558.911 125.295L464.633 70.5338C469.504 66.8499 474.412 63.5781 479.332 60.7424L573.611 115.504Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M607.006 134.905C602.086 137.741 597.166 141.012 592.307 144.696L568.18 130.676C573.051 126.992 577.959 123.72 582.879 120.884L607.006 134.905Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M41.5286 368.966C36.2088 372.965 30.7678 376.6 25.2177 379.799L0 365.149C5.55008 361.949 10.9911 358.314 16.3109 354.315L41.5286 368.966Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M31.9316 341.143C29.1202 343.772 26.2482 346.305 23.3398 348.729L48.5576 363.379C51.4659 360.956 54.3258 358.423 57.1493 355.794L31.9316 341.143Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M46.5948 326.019C43.9773 328.988 41.2992 331.872 38.5605 334.671L47.4552 339.834C50.1939 337.046 52.872 334.162 55.4895 331.181L46.5948 326.019Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M61.9718 334.95C59.3543 337.919 56.6762 340.803 53.9375 343.603L166.224 408.834C168.962 406.047 171.64 403.163 174.258 400.182L61.9718 334.95Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M61.0879 309.72C58.3008 312.58 55.55 315.585 52.8477 318.7L61.7423 323.862C64.4446 320.736 67.1833 317.742 69.9826 314.882L61.0879 309.72Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M76.4649 318.651C73.6777 321.511 70.9269 324.517 68.2246 327.631L116.794 355.83C119.496 352.703 122.235 349.71 125.034 346.85L76.4649 318.651Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M131.93 350.861C129.143 353.721 126.392 356.726 123.689 359.841L180.511 392.862C183.213 389.736 185.952 386.743 188.751 383.883L131.93 350.861Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M76.4683 295.603C73.56 297.966 70.6759 300.486 67.8281 303.128L76.7228 308.29C79.5705 305.637 82.4546 303.128 85.363 300.765L76.4683 295.603Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M190.995 341.603C188.038 343.433 185.081 345.42 182.148 347.553L191.043 352.716C193.976 350.583 196.932 348.595 199.889 346.766L190.995 341.603Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M151.815 318.857C148.858 320.687 145.901 322.675 142.969 324.807L174.512 343.118C177.445 340.985 180.401 338.998 183.358 337.168L151.815 318.857Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M107.67 293.204C104.714 295.034 101.757 297.021 98.8242 299.154L135.324 320.36C138.256 318.228 141.213 316.24 144.17 314.41L107.67 293.204Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M123.579 284.878C120.646 286.138 117.689 287.556 114.732 289.132L128.535 297.154C131.492 295.578 134.436 294.148 137.381 292.9L123.579 284.878Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M146.278 298.063C143.345 299.323 140.388 300.741 137.432 302.316L151.234 310.339C154.191 308.763 157.136 307.333 160.08 306.085L146.278 298.063Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M92.2896 284.272C89.3327 286.102 86.3759 288.09 83.4434 290.222L92.338 295.385C95.2706 293.252 98.2274 291.265 101.184 289.435L92.2896 284.272Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M108.202 275.935C105.269 277.196 102.312 278.613 99.3555 280.189L108.25 285.351C111.207 283.776 114.152 282.346 117.096 281.098L108.202 275.935Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M123.848 270.797C120.988 271.44 118.104 272.264 115.184 273.257L124.078 278.42C126.987 277.426 129.883 276.602 132.743 275.96L123.848 270.797Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M138.862 269.052C136.148 269.052 133.397 269.222 130.598 269.585L139.492 274.748C142.292 274.384 145.055 274.202 147.757 274.215L138.862 269.052Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M153.183 268.495C150.444 268.858 147.766 269.076 145.137 269.137L154.031 274.299C156.661 274.239 159.339 274.02 162.078 273.657L153.183 268.495Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M168.442 264.968C165.522 265.913 162.65 266.689 159.826 267.307L168.721 272.469C171.544 271.851 174.416 271.076 177.337 270.131L168.442 264.968Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M167.713 310.52C164.781 311.781 161.824 313.198 158.867 314.774L190.411 333.084C193.367 331.509 196.312 330.079 199.257 328.831L167.713 310.52Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M183.36 305.382C180.5 306.024 177.616 306.848 174.695 307.842L206.239 326.152C209.147 325.159 212.043 324.335 214.903 323.693L183.36 305.382Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M221.046 316.797C218.331 316.797 215.581 316.967 212.781 317.331L221.664 322.493C224.463 322.129 227.226 321.948 229.928 321.96L221.046 316.797Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M235.371 316.228C232.632 316.592 229.954 316.81 227.324 316.87L236.207 322.033C238.836 321.972 241.514 321.754 244.253 321.39L235.371 316.228Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M250.628 312.701C247.707 313.647 244.835 314.422 242.012 315.04L250.894 320.203C253.718 319.584 256.59 318.809 259.51 317.864L250.628 312.701Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M206.893 333.278C203.96 334.538 201.004 335.956 198.047 337.531L206.942 342.694C209.898 341.118 212.843 339.688 215.788 338.44L206.893 333.278Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M222.547 328.127C219.687 328.77 216.803 329.594 213.883 330.587L222.777 335.75C225.686 334.756 228.582 333.932 231.442 333.29L222.547 328.127Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M237.563 326.395C234.849 326.395 232.098 326.564 229.299 326.928L238.194 332.09C240.993 331.726 243.756 331.545 246.458 331.557L237.563 326.395Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M251.888 325.825C249.15 326.189 246.471 326.407 243.842 326.468L252.736 331.63C255.366 331.569 258.044 331.351 260.783 330.988L251.888 325.825Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M267.141 322.312C264.221 323.257 261.349 324.032 258.525 324.65L267.42 329.813C270.244 329.195 273.116 328.419 276.036 327.474L267.141 322.312Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M268.753 305.019C265.675 306.618 262.646 308.06 259.641 309.333L268.523 314.495C271.528 313.223 274.558 311.781 277.636 310.181L268.753 305.019Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M285.285 314.616C282.207 316.216 279.177 317.658 276.172 318.93L285.067 324.093C288.072 322.82 291.101 321.378 294.179 319.779L285.285 314.616Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M139.223 279.728C136.363 280.37 133.479 281.194 130.559 282.188L139.453 287.35C142.362 286.357 145.258 285.533 148.118 284.89L139.223 279.728Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M155.063 288.938C152.203 289.58 149.319 290.404 146.398 291.398L167.06 303.407C169.968 302.413 172.864 301.601 175.724 300.947L155.063 288.938Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M170.075 287.193C167.361 287.193 164.61 287.363 161.811 287.726L205.133 312.883C207.932 312.52 210.695 312.338 213.397 312.35L170.075 287.193Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M184.4 286.623C181.661 286.987 178.983 287.205 176.354 287.266L219.676 312.423C222.305 312.362 224.983 312.144 227.722 311.78L184.4 286.623Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M199.657 283.109C196.737 284.054 193.865 284.83 191.041 285.448L234.363 310.605C237.187 309.987 240.059 309.211 242.979 308.266L199.657 283.109Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M217.8 275.426C214.722 277.026 211.693 278.468 208.688 279.74L252.01 304.897C255.015 303.625 258.044 302.183 261.122 300.583L217.8 275.426Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M186.582 257.286C183.504 258.885 180.474 260.327 177.469 261.6L201.741 275.705C204.747 274.433 207.776 272.991 210.854 271.391L186.582 257.286Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M154.251 277.995C151.536 277.995 148.786 278.165 145.986 278.528L154.881 283.691C157.68 283.327 160.443 283.145 163.146 283.157L154.251 277.995Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M168.576 277.426C165.837 277.79 163.159 278.008 160.529 278.068L169.424 283.231C172.054 283.17 174.732 282.952 177.47 282.588L168.576 277.426Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M183.819 273.911C180.899 274.857 178.027 275.632 175.203 276.25L184.098 281.412C186.921 280.794 189.793 280.019 192.714 279.074L183.819 273.911Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M91.8414 304.534C88.933 306.897 86.0489 309.418 83.2012 312.059L158.879 356.024C161.726 353.37 164.61 350.861 167.519 348.498L91.8414 304.534Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M175.168 352.934C172.259 355.297 169.375 357.817 166.527 360.459L195.49 377.291C198.337 374.637 201.221 372.129 204.13 369.766L175.168 352.934Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M206.53 350.631C203.573 352.461 200.616 354.448 197.684 356.581L211.11 364.385C214.043 362.252 217 360.265 219.957 358.435L206.53 350.631Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M222.44 342.306C219.507 343.566 216.551 344.984 213.594 346.56L227.021 354.364C229.977 352.788 232.922 351.358 235.867 350.11L222.44 342.306Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M238.082 337.156C235.223 337.798 232.338 338.622 229.418 339.616L242.845 347.42C245.753 346.426 248.649 345.602 251.509 344.96L238.082 337.156Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M253.097 335.423C250.382 335.423 247.631 335.593 244.832 335.956L258.259 343.76C261.058 343.397 263.821 343.215 266.523 343.227L253.097 335.423Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M267.421 334.853C264.683 335.217 262.005 335.435 259.375 335.495L272.802 343.299C275.431 343.239 278.11 343.021 280.848 342.657L267.421 334.853Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M282.678 331.339C279.758 332.284 276.886 333.06 274.062 333.678L287.489 341.482C290.313 340.864 293.185 340.088 296.105 339.143L282.678 331.339Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M300.82 323.644C297.742 325.244 294.712 326.686 291.707 327.958L305.134 335.762C308.139 334.49 311.169 333.048 314.247 331.448L300.82 323.644Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M287.309 293.506C284.303 295.675 281.262 297.711 278.184 299.626L323.675 326.055C326.753 324.141 329.794 322.105 332.8 319.936L287.309 293.506Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M205.135 245.761C202.129 247.93 199.088 249.966 196.01 251.881L270.548 295.179C273.626 293.264 276.668 291.228 279.673 289.059L205.135 245.761Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M64.1659 359.877C61.3545 362.507 58.4826 365.04 55.5742 367.463L97.6845 391.917C100.593 389.494 103.453 386.961 106.276 384.331L64.1659 359.877Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M113.316 388.415C110.505 391.045 107.633 393.577 104.725 396.001L124.186 407.307C127.095 404.884 129.954 402.351 132.778 399.721L113.316 388.415Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M159.596 415.317C149.514 424.757 138.789 432.9 127.665 439.323L108.203 428.017C119.328 421.594 130.052 413.451 140.134 404.011L159.596 415.317Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M117.168 412.894C111.848 416.893 106.407 420.528 100.857 423.727L32.2441 383.871C37.7942 380.672 43.2352 377.036 48.5551 373.037L117.168 412.894Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M236.871 216.969C229.709 224.942 222.111 232.274 214.186 238.793L308.464 293.555C316.389 287.035 323.987 279.704 331.149 271.73L236.871 216.969Z",
  fill: "#0D4A8B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M340.408 277.123C333.246 285.096 325.648 292.428 317.723 298.947L341.85 312.968C349.775 306.449 357.373 299.117 364.535 291.143L340.408 277.123Z",
  fill: "#0D4A8B"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M406.901 442.819H218.634C201.39 442.819 187.418 428.847 187.418 411.603V31.2162C187.418 13.9721 201.39 0 218.634 0H406.901C424.145 0 438.117 13.9721 438.117 31.2162V411.603C438.117 428.847 424.145 442.819 406.901 442.819Z",
  fill: "#185392"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M405.107 437.778H220.44C204.989 437.778 192.459 425.248 192.459 409.797V33.0219C192.459 17.5713 204.989 5.04126 220.44 5.04126H405.107C420.557 5.04126 433.088 17.5713 433.088 33.0219V409.797C433.075 425.248 420.557 437.778 405.107 437.778Z",
  fill: "#EBE3FF"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.15
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.15
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M307.961 319.21L309.379 319.028C309.536 318.919 309.694 318.81 309.876 318.713L419.568 255.384C422.404 253.748 427.348 253.954 430.62 255.845L494.616 292.793C495.464 293.29 496.118 293.847 496.567 294.429L497.318 294.211V296.428C497.306 297.458 496.688 298.44 495.415 299.179L385.723 362.508C382.887 364.144 377.943 363.938 374.671 362.048L310.675 325.099C308.846 324.045 307.937 322.688 307.973 321.403V319.21H307.961Z",
  fill: "#9FFFF8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M385.712 360.278L495.404 296.949C498.24 295.313 497.888 292.453 494.604 290.563L430.609 253.615C427.337 251.724 422.381 251.518 419.557 253.154L309.864 316.483C307.029 318.119 307.38 320.979 310.664 322.869L374.66 359.818C377.932 361.708 382.888 361.914 385.712 360.278Z",
  fill: "#42E8E0"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.15
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M459.595 303.881L473.143 296.065C474.403 295.337 474.246 294.065 472.792 293.229C471.338 292.393 469.132 292.296 467.872 293.023L454.324 300.839C453.064 301.566 453.221 302.839 454.675 303.675C456.129 304.511 458.335 304.608 459.595 303.881Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M434.609 318.301L448.157 310.485C449.417 309.758 449.26 308.485 447.805 307.649C446.351 306.813 444.146 306.716 442.885 307.443L429.337 315.259C428.077 315.987 428.235 317.259 429.689 318.095C431.143 318.943 433.349 319.028 434.609 318.301Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M409.609 332.734L423.157 324.918C424.417 324.19 424.26 322.918 422.805 322.082C421.351 321.246 419.146 321.149 417.885 321.876L404.337 329.692C403.077 330.419 403.235 331.692 404.689 332.528C406.155 333.376 408.349 333.461 409.609 332.734Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M384.622 347.166L398.171 339.35C399.431 338.623 399.273 337.351 397.819 336.515C396.365 335.678 394.159 335.581 392.899 336.309L379.351 344.125C378.091 344.852 378.248 346.124 379.703 346.96C381.157 347.796 383.362 347.893 384.622 347.166Z",
  fill: "white"
})));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M307.961 294.295L309.379 294.113C309.536 294.004 309.694 293.895 309.876 293.798L419.568 230.469C422.404 228.833 427.348 229.039 430.62 230.93L494.616 267.878C495.464 268.375 496.118 268.932 496.567 269.514L497.318 269.295V271.513C497.306 272.543 496.688 273.525 495.415 274.264L385.723 337.593C382.887 339.229 377.943 339.023 374.671 337.132L310.675 300.184C308.846 299.13 307.937 297.773 307.973 296.488V294.295H307.961Z",
  fill: "#A3F5FE"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M385.712 335.351L495.404 272.022C498.24 270.386 497.888 267.526 494.604 265.636L430.609 228.688C427.337 226.798 422.381 226.592 419.557 228.227L309.864 291.557C307.029 293.192 307.38 296.052 310.664 297.943L374.66 334.891C377.932 336.781 382.888 336.987 385.712 335.351Z",
  fill: "#42E8E0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M385.712 335.351L495.404 272.022C498.24 270.386 497.888 267.526 494.604 265.636L430.609 228.688C427.337 226.798 422.381 226.592 419.557 228.227L309.864 291.557C307.029 293.192 307.38 296.052 310.664 297.943L374.66 334.891C377.932 336.781 382.888 336.987 385.712 335.351Z",
  fill: "url(#paint3_radial_233_16300)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M368.019 331.061L487.976 261.807L475.24 254.451L355.283 323.706L368.019 331.061Z",
  fill: "#453C9E"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M495.405 270.653L385.712 333.982C382.877 335.618 377.932 335.412 374.66 333.521L310.665 296.573C309.199 295.725 308.326 294.695 308.06 293.653C307.672 295.095 308.556 296.707 310.665 297.931L374.66 334.879C377.932 336.769 382.889 336.975 385.712 335.339L495.405 272.01C496.968 271.101 497.562 269.829 497.223 268.544C497.005 269.344 496.411 270.083 495.405 270.653Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M369.91 300.524L406.022 279.669L397.212 274.591L361.088 295.434L369.91 300.524Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.15
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M164.137 287.194L164.246 297.118H164.258C164.246 297.252 164.319 297.385 164.488 297.482L272.824 358.557C273.175 358.751 273.793 358.727 274.193 358.484L291.692 348.135C291.885 348.026 291.995 347.881 292.019 347.736V347.723C292.019 347.711 292.019 347.699 292.019 347.687L291.91 337.665L283.415 342.61L183.453 286.248C183.102 286.055 182.483 286.079 182.084 286.321L176.073 289.872L164.137 287.194Z",
  fill: "url(#paint4_linear_233_16300)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M183.344 276.287L291.68 337.363C292.031 337.556 291.995 337.92 291.595 338.15L274.096 348.499C273.697 348.741 273.079 348.766 272.727 348.572L164.392 287.497C164.04 287.303 164.076 286.939 164.476 286.709L181.975 276.36C182.375 276.13 182.981 276.094 183.344 276.287Z",
  fill: "url(#paint5_linear_233_16300)"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M278.726 216.521C277.72 204.803 268.28 191.243 257.616 186.25C252.284 183.754 247.655 183.875 244.492 186.093L241.196 188.419L242.214 188.431C240.578 190.831 239.79 194.224 240.154 198.441C241.16 210.159 250.6 223.719 261.263 228.712C264.923 230.433 268.256 230.905 270.994 230.324V231.257L274.351 228.894C274.363 228.881 274.375 228.869 274.387 228.869L274.521 228.772H274.508C277.574 226.531 279.222 222.277 278.726 216.521Z",
  fill: "#9FFFF8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M275.38 218.872C276.386 230.59 268.557 236.055 257.906 231.051C247.254 226.058 237.802 212.51 236.796 200.78C235.79 189.062 243.618 183.596 254.27 188.601C264.934 193.594 274.386 207.154 275.38 218.872Z",
  fill: "#42E8E0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M264.266 230.518C262.218 230.518 259.964 229.96 257.589 228.845C248.1 224.398 239.654 212.292 238.769 201.858C238.333 196.744 239.739 192.782 242.744 190.685C245.749 188.589 249.954 188.637 254.608 190.819C264.096 195.266 272.542 207.372 273.427 217.818C273.863 222.932 272.458 226.894 269.452 228.991C267.974 230.009 266.217 230.518 264.266 230.518ZM247.931 189.68C246.077 189.68 244.416 190.164 243.047 191.122C240.211 193.097 238.878 196.902 239.29 201.822C240.163 212.086 248.476 224.01 257.807 228.385C262.278 230.481 266.302 230.542 269.137 228.567C271.973 226.591 273.306 222.786 272.894 217.866C272.021 207.59 263.708 195.678 254.377 191.303C252.075 190.213 249.894 189.68 247.931 189.68Z",
  fill: "#18B2A3"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M253.018 175.889C264.433 173.029 276.309 161.554 279.544 150.235C281.168 144.564 280.308 140.02 277.618 137.257L274.794 134.373L274.952 135.379C272.322 134.142 268.844 133.912 264.736 134.93C253.321 137.79 241.445 149.266 238.21 160.584C237.095 164.474 237.155 167.831 238.161 170.448L237.24 170.606L240.112 173.538C240.124 173.55 240.136 173.563 240.149 173.575L240.27 173.696V173.684C242.948 176.35 247.395 177.295 253.018 175.889Z",
  fill: "#8BD5DD"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M266.484 163.32C276.841 153.303 280.549 140.335 274.766 134.355C268.983 128.376 255.898 131.649 245.541 141.666C235.183 151.683 231.475 164.651 237.259 170.631C243.042 176.611 256.127 173.338 266.484 163.32Z",
  fill: "#A7F4FE"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M246.488 171.442C243.483 171.442 240.987 170.521 239.242 168.715C236.697 166.086 236.079 161.917 237.484 156.985C240.369 146.915 250.972 136.651 261.139 134.106C266.119 132.858 270.264 133.622 272.809 136.251C275.353 138.881 275.971 143.049 274.566 147.981C271.682 158.052 261.078 168.316 250.911 170.86C249.336 171.248 247.858 171.442 246.488 171.442ZM265.538 134.058C264.205 134.058 262.775 134.252 261.248 134.627C251.251 137.124 240.805 147.23 237.969 157.143C236.612 161.893 237.194 165.868 239.593 168.364C242.004 170.848 245.967 171.563 250.754 170.364C260.751 167.855 271.197 157.761 274.033 147.848C275.39 143.098 274.808 139.123 272.409 136.627C270.773 134.918 268.41 134.058 265.538 134.058Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M164 277.523L164.109 287.448H164.121C164.109 287.581 164.182 287.715 164.351 287.811L272.687 348.887C273.038 349.08 273.656 349.056 274.056 348.814L291.555 338.465C291.749 338.356 291.858 338.211 291.882 338.065V338.053C291.882 338.041 291.882 338.029 291.882 338.017L291.773 327.995L283.278 332.939L183.316 276.578C182.965 276.384 182.347 276.408 181.947 276.651L175.936 280.201L164 277.523Z",
  fill: "url(#paint6_linear_233_16300)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M164 277.523L164.109 287.448H164.121C164.109 287.581 164.182 287.715 164.351 287.811L272.687 348.887C273.038 349.08 273.656 349.056 274.056 348.814L291.555 338.465C291.749 338.356 291.858 338.211 291.882 338.065V338.053C291.882 338.041 291.882 338.029 291.882 338.017L291.773 327.995L283.278 332.939L183.316 276.578C182.965 276.384 182.347 276.408 181.947 276.651L175.936 280.201L164 277.523Z",
  fill: "url(#paint7_radial_233_16300)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M183.207 266.617L291.543 327.692C291.894 327.886 291.858 328.25 291.458 328.48L273.96 338.829C273.56 339.071 272.942 339.095 272.59 338.901L164.255 277.826C163.903 277.632 163.94 277.269 164.34 277.039L181.838 266.69C182.238 266.459 182.856 266.423 183.207 266.617Z",
  fill: "url(#paint8_linear_233_16300)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M291.542 327.704L291.239 327.535L273.947 337.75C273.547 337.993 272.929 338.017 272.577 337.823L164.545 276.917L164.339 277.039C163.939 277.281 163.89 277.632 164.254 277.826L272.589 338.901C272.941 339.095 273.559 339.071 273.959 338.829L291.457 328.48C291.857 328.25 291.894 327.898 291.542 327.704Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M187.219 281.51L272.336 328.613C272.942 325.244 273.887 321.839 275.16 318.47L190.188 270.568C188.818 274.191 187.813 277.875 187.219 281.51Z",
  fill: "#24126A"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M179.51 272.373L281.665 329.97C281.908 330.104 281.884 330.346 281.605 330.516L277.206 333.109C276.927 333.266 276.515 333.291 276.273 333.157L174.118 275.56C173.875 275.427 173.899 275.185 174.178 275.015L178.577 272.422C178.844 272.264 179.268 272.24 179.51 272.373Z",
  fill: "#24126A"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M174.117 275.56L176.189 276.736L178.564 275.33C178.843 275.173 179.255 275.148 179.497 275.282L279.568 331.703L281.592 330.504C281.871 330.346 281.895 330.104 281.653 329.958L179.497 272.361C179.255 272.228 178.831 272.252 178.564 272.41L174.165 275.003C173.899 275.185 173.874 275.427 174.117 275.56Z",
  fill: "#453C9E"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M435.154 169.915L350.169 122C350.327 137.16 339.869 155.7 326.818 163.42L210.727 232.044C195.385 241.109 183.098 262.909 183.279 280.735L268.263 328.65C268.082 310.824 280.369 289.036 295.711 279.959L411.802 211.334C424.853 203.615 435.299 185.075 435.154 169.915Z",
  fill: "url(#paint9_linear_233_16300)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M435.154 169.915L350.169 122C350.327 137.16 339.869 155.7 326.818 163.42L210.727 232.044C195.385 241.109 183.098 262.909 183.279 280.735L268.263 328.65C268.082 310.824 280.369 289.036 295.711 279.959L411.802 211.334C424.853 203.615 435.299 185.075 435.154 169.915Z",
  fill: "url(#paint10_radial_233_16300)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M183.268 280.723L268.252 328.638C268.24 327.85 268.264 327.062 268.312 326.262H268.3L183.328 278.36C183.292 279.159 183.268 279.947 183.268 280.723Z",
  fill: "#453C9E"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M323.266 230.421L340.013 239.861L338.413 240.806L321.666 231.366L323.266 230.421Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M314.674 225.573L320.709 228.978L319.109 229.924L313.074 226.518L314.674 225.573Z",
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M308.021 221.829L312.117 224.132L310.518 225.077L306.422 222.762L308.021 221.829Z",
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M334.535 232.553L343.66 237.703L342.06 238.649L332.936 233.498L334.535 232.553Z",
  fill: "white"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M320.795 224.81L331.98 231.111L330.38 232.057L319.195 225.755L320.795 224.81Z",
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M314.143 221.053L318.238 223.368L316.639 224.313L312.543 221.998L314.143 221.053Z",
  fill: "white"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M307.803 217.491L311.899 219.793L310.299 220.738L306.203 218.436L307.803 217.491Z",
  fill: "white"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M340.701 231.826L347.306 235.547L345.706 236.492L339.102 232.772L340.701 231.826Z",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M335.891 229.112L338.145 230.384L336.545 231.329L334.291 230.057L335.891 229.112Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M329.226 225.355L333.322 227.67L331.735 228.615L327.639 226.3L329.226 225.355Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M326.586 219.648L350.955 233.39L349.356 234.335L324.986 220.593L326.586 219.648Z",
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M317.994 214.812L324.029 218.206L322.429 219.151L316.395 215.758L317.994 214.812Z",
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M347.998 227.512L354.602 231.232L353.003 232.178L346.398 228.457L347.998 227.512Z",
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M332.5 218.775L345.442 226.07L343.842 227.015L330.912 219.72L332.5 218.775Z",
  fill: "white"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M325.846 215.018L329.942 217.333L328.354 218.278L324.246 215.964L325.846 215.018Z",
  fill: "white"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M344.738 221.465L358.25 229.075L356.65 230.021L343.139 222.411L344.738 221.465Z",
  fill: "white"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M332.414 214.51L342.181 220.023L340.582 220.969L330.814 215.455L332.414 214.51Z",
  fill: "white"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M323.254 209.347L329.858 213.068L328.259 214.013L321.654 210.293L323.254 209.347Z",
  fill: "white"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M357.33 224.349L361.899 226.918L360.299 227.864L355.73 225.295L357.33 224.349Z",
  fill: "white"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M348.75 219.502L354.773 222.907L353.173 223.852L347.15 220.447L348.75 219.502Z",
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M336.475 212.583L346.193 218.06L344.594 219.005L334.875 213.528L336.475 212.583Z",
  fill: "white"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M351.576 216.885L365.548 224.762L363.949 225.707L349.977 217.83L351.576 216.885Z",
  fill: "white"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M335.918 208.063L349.005 215.443L347.418 216.388L334.318 209.008L335.918 208.063Z",
  fill: "white"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M329.266 204.306L333.362 206.621L331.762 207.566L327.666 205.251L329.266 204.306Z",
  fill: "white"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M322.877 200.707L326.973 203.022L325.373 203.967L321.277 201.652L322.877 200.707Z",
  fill: "white"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M360.818 217.891L369.192 222.605L367.592 223.55L359.219 218.836L360.818 217.891Z",
  fill: "white"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M289.299 211.262L277.689 204.718L276.09 205.663L287.699 212.207L289.299 211.262Z",
  fill: "white"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M290.463 207.711L281.338 202.561L279.738 203.506L288.863 208.656L290.463 207.711Z",
  fill: "white"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M291.587 204.136L284.982 200.404L283.383 201.349L289.987 205.07L291.587 204.136Z",
  fill: "white"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M298.228 203.664L288.631 198.247L287.031 199.192L296.629 204.609L298.228 203.664Z",
  fill: "white"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M298.884 199.823L292.279 196.103L290.68 197.036L297.284 200.768L298.884 199.823Z",
  fill: "white"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M304.301 198.659L295.928 193.945L294.328 194.891L302.702 199.604L304.301 198.659Z",
  fill: "white"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M304.133 194.357L299.576 191.788L297.977 192.734L302.545 195.303L304.133 194.357Z",
  fill: "white"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M312.057 194.612L303.223 189.631L301.623 190.576L310.469 195.557L312.057 194.612Z",
  fill: "white"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M315.243 192.188L306.869 187.474L305.27 188.419L313.643 193.133L315.243 192.188Z",
  fill: "white"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M354.699 214.437L358.262 216.449L356.662 217.394L353.1 215.382L354.699 214.437Z",
  fill: "white"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M344.121 208.475L352.143 212.995L350.543 213.94L342.533 209.42L344.121 208.475Z",
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M353.971 192.067L367.494 199.702L365.895 200.635L352.371 193.012L353.971 192.067Z",
  fill: "white"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M344.703 186.844L350.035 189.849L348.435 190.794L343.115 187.789L344.703 186.844Z",
  fill: "white"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M288.082 251.216L304.817 260.656L303.23 261.601L286.482 252.161L288.082 251.216Z",
  fill: "white"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M279.49 246.381L285.513 249.774L283.925 250.719L277.891 247.326L279.49 246.381Z",
  fill: "white"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M272.838 242.624L276.934 244.939L275.334 245.884L271.238 243.569L272.838 242.624Z",
  fill: "white"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M299.339 253.361L308.464 258.499L306.877 259.444L297.752 254.306L299.339 253.361Z",
  fill: "white"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M285.611 245.617L296.784 251.918L295.197 252.864L284.012 246.562L285.611 245.617Z",
  fill: "white"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M278.959 241.86L283.055 244.175L281.455 245.12L277.359 242.806L278.959 241.86Z",
  fill: "white"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M272.619 238.286L276.715 240.6L275.115 241.545L271.02 239.231L272.619 238.286Z",
  fill: "white"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M305.518 252.621L312.11 256.341L310.522 257.287L303.918 253.566L305.518 252.621Z",
  fill: "white"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M300.695 249.907L302.961 251.179L301.361 252.125L299.107 250.852L300.695 249.907Z",
  fill: "white"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M294.043 246.163L298.139 248.465L296.539 249.41L292.443 247.108L294.043 246.163Z",
  fill: "white"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M291.402 240.455L315.76 254.185L314.172 255.13L289.803 241.4L291.402 240.455Z",
  fill: "white"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M282.811 235.607L288.845 239.013L287.246 239.958L281.211 236.553L282.811 235.607Z",
  fill: "white"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M254.115 232.069L242.506 225.525L240.906 226.47L252.515 233.014L254.115 232.069Z",
  fill: "white"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M255.279 228.506L246.154 223.368L244.555 224.314L253.68 229.452L255.279 228.506Z",
  fill: "white"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M256.391 224.931L249.799 221.211L248.199 222.156L254.804 225.877L256.391 224.931Z",
  fill: "white"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M263.045 224.471L253.447 219.054L251.848 219.999L261.445 225.416L263.045 224.471Z",
  fill: "white"
});

var _ref84 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M394.536 188.722C394.536 176.956 386.271 162.656 376.092 156.767C370.99 153.822 366.373 153.544 363.029 155.483L359.539 157.518L360.557 157.615C358.715 159.869 357.648 163.19 357.648 167.407C357.648 179.173 365.913 193.473 376.092 199.362C379.594 201.386 382.866 202.149 385.653 201.798L385.581 202.731L389.119 200.659C389.131 200.647 389.143 200.647 389.168 200.635L389.313 200.55H389.301C392.536 198.599 394.536 194.515 394.536 188.722Z",
  fill: "#9FFFF8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M385.601 202.743C392.806 198.584 392.805 185.096 385.601 172.618C378.396 160.139 366.715 153.395 359.511 157.555C352.307 161.714 352.307 175.202 359.512 187.68C366.717 200.159 378.397 206.902 385.601 202.743Z",
  fill: "#42E8E0"
}));

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M394.536 188.722C394.536 176.956 386.271 162.656 376.092 156.767C370.99 153.822 366.373 153.544 363.029 155.483L359.539 157.518L360.557 157.615C358.715 159.869 357.648 163.19 357.648 167.407C357.648 179.173 365.913 193.473 376.092 199.362C379.594 201.386 382.866 202.149 385.653 201.798L385.581 202.731L389.119 200.659C389.131 200.647 389.143 200.647 389.168 200.635L389.313 200.55H389.301C392.536 198.599 394.536 194.515 394.536 188.722Z",
  fill: "#8BD5DD"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M385.601 202.743C392.806 198.584 392.805 185.096 385.601 172.618C378.396 160.139 366.715 153.395 359.511 157.555C352.307 161.714 352.307 175.202 359.512 187.68C366.717 200.159 378.397 206.902 385.601 202.743Z",
  fill: "#A7F4FE"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M379.98 201.858C377.654 201.858 375.085 201.083 372.431 199.544C363.197 194.212 355.684 181.197 355.684 170.533C355.684 165.31 357.453 161.408 360.676 159.554C363.9 157.688 368.165 158.112 372.685 160.718C381.919 166.049 389.432 179.064 389.432 189.728C389.432 194.951 387.663 198.853 384.428 200.719C383.119 201.483 381.604 201.858 379.98 201.858ZM365.148 158.948C363.609 158.948 362.191 159.3 360.955 160.027C357.901 161.796 356.217 165.528 356.217 170.557C356.217 181.052 363.609 193.86 372.697 199.108C377.048 201.616 381.132 202.028 384.185 200.271C387.239 198.502 388.923 194.769 388.923 189.74C388.923 179.246 381.531 166.437 372.443 161.19C369.85 159.7 367.365 158.948 365.148 158.948Z",
  fill: "white"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M222.29 291.896C222.29 280.129 214.025 265.83 203.846 259.94C198.744 256.995 194.127 256.717 190.783 258.656L187.293 260.691L188.311 260.788C186.469 263.042 185.402 266.363 185.402 270.58C185.402 282.346 193.667 296.646 203.846 302.535C207.348 304.559 210.62 305.322 213.407 304.971L213.335 305.904L216.873 303.832C216.885 303.82 216.897 303.82 216.921 303.808L217.067 303.723H217.055C220.29 301.772 222.29 297.688 222.29 291.896Z",
  fill: "#8BD5DD"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M213.353 305.898C220.558 301.739 220.557 288.251 213.353 275.773C206.148 263.294 194.467 256.551 187.263 260.71C180.059 264.87 180.059 278.357 187.264 290.836C194.468 303.314 206.149 310.058 213.353 305.898Z",
  fill: "#A7F4FE"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M207.456 304.22C205.227 304.22 202.742 303.468 200.185 301.99C191.303 296.864 184.068 284.346 184.068 274.082C184.068 269.053 185.777 265.296 188.879 263.503C191.981 261.709 196.089 262.109 200.44 264.618C209.322 269.744 216.557 282.262 216.557 292.526C216.557 297.555 214.848 301.311 211.746 303.093C210.474 303.844 209.019 304.22 207.456 304.22ZM193.181 262.933C191.703 262.933 190.346 263.273 189.146 263.963C186.213 265.66 184.602 269.247 184.602 274.082C184.602 284.176 191.715 296.488 200.452 301.529C204.633 303.941 208.559 304.341 211.492 302.644C214.424 300.948 216.036 297.361 216.036 292.526C216.036 282.431 208.923 270.119 200.185 265.078C197.713 263.66 195.326 262.933 193.181 262.933Z",
  fill: "white"
});

var _ref91 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M222.292 352.813C222.292 341.046 214.027 326.747 203.848 320.858C198.746 317.913 194.129 317.634 190.785 319.573L187.295 321.609L188.313 321.706C186.471 323.96 185.404 327.28 185.404 331.497C185.404 343.264 193.669 357.563 203.848 363.453C207.35 365.476 210.622 366.24 213.409 365.888L213.336 366.822L216.875 364.749C216.887 364.737 216.899 364.737 216.923 364.725L217.069 364.64H217.057C220.292 362.689 222.292 358.593 222.292 352.813Z",
  fill: "#9FFFF8"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M213.355 366.815C220.559 362.656 220.559 349.168 213.355 336.69C206.15 324.211 194.469 317.468 187.265 321.627C180.061 325.787 180.061 339.274 187.266 351.753C194.47 364.231 206.151 370.975 213.355 366.815Z",
  fill: "#42E8E0"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M207.458 365.125C205.228 365.125 202.744 364.374 200.187 362.896C191.305 357.77 184.07 345.252 184.07 334.988C184.07 329.959 185.779 326.202 188.881 324.421C191.983 322.627 196.091 323.027 200.442 325.536C209.324 330.661 216.559 343.179 216.559 353.443C216.559 358.472 214.85 362.229 211.748 364.01C210.476 364.762 209.021 365.125 207.458 365.125ZM193.183 323.851C191.705 323.851 190.347 324.19 189.148 324.881C186.215 326.578 184.603 330.165 184.603 335C184.603 345.094 191.717 357.406 200.454 362.447C204.635 364.859 208.561 365.259 211.494 363.562C214.426 361.866 216.038 358.279 216.038 353.443C216.038 343.349 208.924 331.037 200.187 325.996C197.715 324.566 195.328 323.851 193.183 323.851Z",
  fill: "#18B2A3"
}));

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M192.125 31.2498C192.125 16.6142 203.989 4.74976 218.625 4.74976H406.937C421.572 4.74976 433.437 16.6142 433.437 31.2498V61.0912H192.125V31.2498Z",
  fill: "#0961BF"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M433.438 411.973C433.438 426.608 421.573 438.473 406.938 438.473L218.626 438.473C203.99 438.473 192.126 426.608 192.126 411.973L192.126 394.888L433.438 394.888L433.438 411.973Z",
  fill: "#0961BF"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M280.447 102.671C279.556 102.301 278.746 101.777 278.058 101.117C277.35 100.457 276.803 99.6799 276.438 98.8067C276.033 97.9128 275.83 96.9811 275.83 95.991C275.83 92.0099 279.231 88.7661 283.382 88.7661C284.556 88.7661 285.731 89.0377 286.764 89.5431C287.796 90.0278 288.728 90.7859 289.416 91.6798L289.74 92.0683L287.574 93.6035L287.271 93.215C286.361 92.0306 284.943 91.3498 283.384 91.3498C280.712 91.3498 278.524 93.4281 278.524 95.991C278.524 98.5747 280.71 100.672 283.384 100.672C284.923 100.672 286.341 99.9929 287.271 98.8067L287.574 98.4371L289.721 99.9514L289.396 100.34C288.689 101.253 287.796 101.971 286.744 102.477C285.712 102.982 284.558 103.235 283.384 103.235C282.371 103.235 281.378 103.041 280.447 102.671Z",
  fill: "#0056D2"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M291.765 101.875C290.855 100.962 290.348 99.7779 290.348 98.5728C290.348 97.3488 290.853 96.1645 291.765 95.2706C292.697 94.4163 293.912 93.9297 295.208 93.9297C296.544 93.9297 297.759 94.4144 298.628 95.2706C299.56 96.1645 300.066 97.33 300.066 98.5728C300.066 99.8156 299.56 100.981 298.628 101.875C297.718 102.748 296.503 103.235 295.208 103.235C293.953 103.235 292.717 102.75 291.765 101.875ZM292.738 98.5728C292.738 99.9137 293.851 101 295.208 101C296.584 101 297.699 99.9118 297.699 98.5728C297.699 97.2319 296.586 96.1456 295.208 96.1456C293.851 96.1456 292.738 97.2338 292.738 98.5728Z",
  fill: "#0056D2"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M313.836 103.022V98.2635C313.836 97.2338 312.925 96.321 311.871 96.321C310.778 96.321 309.888 97.2149 309.888 98.2635V103.022H307.357V98.2635C307.357 97.2149 306.466 96.321 305.393 96.321C304.319 96.321 303.429 97.2338 303.429 98.2635V103.022H300.898V94.1258H303.429V94.767C304.056 94.1654 304.725 93.9504 305.393 93.9504C305.981 93.9504 306.567 94.0674 307.135 94.2993C307.662 94.5332 308.148 94.8632 308.592 95.2706C308.592 95.2894 308.612 95.2894 308.633 95.3102C308.653 95.2913 308.653 95.2913 308.674 95.2706C309.099 94.8632 309.585 94.5332 310.131 94.2993C310.698 94.0655 311.285 93.9504 311.873 93.9504C313.069 93.9504 314.201 94.3974 315.053 95.1933C315.904 96.0287 316.368 97.1169 316.368 98.2616V103.02H313.836V103.022Z",
  fill: "#0056D2"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M325.761 95.2911C326.671 96.1851 327.179 97.3506 327.179 98.5726C327.179 99.7966 326.673 100.962 325.761 101.854C324.851 102.727 323.636 103.195 322.34 103.195C321.489 103.195 320.72 102.905 320.052 102.322L319.95 102.244V108.187H317.5V94.1257H319.95V94.8253L320.052 94.7291C320.781 94.0502 321.611 93.9522 322.34 93.9522C323.616 93.9503 324.829 94.418 325.761 95.2911ZM324.729 98.5726C324.729 97.2902 323.636 96.2228 322.34 96.2228C321.045 96.2228 319.952 97.2902 319.952 98.5726C319.952 99.8343 321.045 100.922 322.34 100.922C323.636 100.922 324.729 99.8362 324.729 98.5726Z",
  fill: "#0056D2"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M328.092 103.021V88.7659H330.724V103.021H328.092Z",
  fill: "#0056D2"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M332.746 91.5622C332.746 91.1548 332.907 90.7852 333.212 90.5136C333.515 90.2232 333.9 90.0667 334.325 90.0667C335.176 90.0667 335.884 90.7456 335.884 91.5622C335.884 92.3788 335.176 93.0577 334.325 93.0577C333.456 93.0577 332.746 92.3769 332.746 91.5622ZM333.01 103.021V94.1251H335.642V103.021H333.01Z",
  fill: "#0056D2"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M338.48 101.856C337.57 100.962 337.062 99.7966 337.062 98.5745C337.062 97.3506 337.568 96.1851 338.48 95.293C339.39 94.4199 340.605 93.9521 341.901 93.9521C342.752 93.9521 343.521 94.2426 344.189 94.8253L344.291 94.9026V94.1257H346.741V103.021H344.291V102.322L344.189 102.418C343.46 103.097 342.63 103.195 341.901 103.195C340.625 103.195 339.41 102.729 338.48 101.856ZM339.512 98.5726C339.512 99.855 340.605 100.922 341.901 100.922C343.196 100.922 344.29 99.855 344.29 98.5726C344.29 97.311 343.196 96.2228 341.901 96.2228C340.605 96.2228 339.512 97.311 339.512 98.5726Z",
  fill: "#0056D2"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M354.9 103.022V98.2635C354.9 97.2149 354.029 96.3983 352.936 96.3983C351.884 96.3983 350.972 97.2338 350.972 98.2635V103.022H348.441V94.1258H350.972V94.767C351.599 94.1654 352.267 93.9504 352.936 93.9504C354.151 93.9504 355.285 94.3974 356.134 95.1933C356.986 96.0287 357.45 97.1169 357.45 98.2616V103.02H354.9V103.022Z",
  fill: "#0056D2"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M362.573 103.021C361.682 103.021 360.853 102.691 360.245 102.108C359.618 101.507 359.294 100.73 359.294 99.8754V96.1847H357.998V94.1837H359.294V90.6873H361.702V94.1837H364.395V96.1847H361.702V99.8358C361.702 100.32 362.148 100.767 362.593 100.767H364.354L365.001 103.021H362.573Z",
  fill: "#0056D2"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M271.889 103.506H275.945C276.244 103.506 276.419 103.191 276.246 102.963L264.955 87.9603C264.886 87.8679 264.774 87.8132 264.654 87.8132H260.598C260.299 87.8132 260.124 88.1282 260.297 88.3564L271.588 103.359C271.655 103.451 271.769 103.506 271.889 103.506Z",
  fill: "#0056D2"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M264.78 103.554H260.309C260.06 103.554 259.912 103.283 260.058 103.087L265.694 95.5073C265.767 95.4092 265.887 95.3489 266.013 95.3489H270.289C270.604 95.3489 270.789 95.6846 270.608 95.9297L265.03 103.43C264.973 103.509 264.88 103.554 264.78 103.554Z",
  fill: "#00E7C5"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M270.843 92.3341C271.966 92.3341 272.876 91.4611 272.876 90.3841C272.876 89.3071 271.966 88.4341 270.843 88.4341C269.721 88.4341 268.811 89.3071 268.811 90.3841C268.811 91.4611 269.721 92.3341 270.843 92.3341Z",
  fill: "#00E7C5"
});

var _ref106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_233_16300",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(523.632 155.776) scale(254.716 254.716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E068D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29013E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_233_16300",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(101.908 155.776) rotate(180) scale(254.716 254.716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E068D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29013E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_233_16300",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(141.025 423.182) rotate(180) scale(254.717 254.717)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8CE2FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.056,
  stopColor: "#79CEFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1806,
  stopColor: "#53A5F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#4B84D2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3927,
  stopColor: "#415DA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5165,
  stopColor: "#393C81"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6395,
  stopColor: "#322364"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7615,
  stopColor: "#2E104F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8822,
  stopColor: "#2B0643"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A023F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_233_16300",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(438.162 250.14) scale(296.49 296.49)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7FDFFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.095,
  stopColor: "#74BAE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.198,
  stopColor: "#6A9AD7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3098,
  stopColor: "#617FC9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4318,
  stopColor: "#5B6BBD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5688,
  stopColor: "#565CB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7335,
  stopColor: "#5454B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5351AF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_233_16300",
  x1: 296.432,
  y1: 320.573,
  x2: 179.106,
  y2: 323.722,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5761D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0398,
  stopColor: "#5C66D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0867,
  stopColor: "#6A73DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1372,
  stopColor: "#8289E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1899,
  stopColor: "#A3A7F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2237,
  stopColor: "#BCBEFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_233_16300",
  x1: 261.137,
  y1: 260.11,
  x2: 216.592,
  y2: 330.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C0BFF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2938,
  stopColor: "#C5C4F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6399,
  stopColor: "#D3D2F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9E9FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_233_16300",
  x1: 296.297,
  y1: 310.901,
  x2: 178.971,
  y2: 314.051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5761D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0398,
  stopColor: "#5C66D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0867,
  stopColor: "#6A73DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1372,
  stopColor: "#8289E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1899,
  stopColor: "#A3A7F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2237,
  stopColor: "#BCBEFF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_233_16300",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(294.82 352.531) rotate(-120.583) scale(94.675 94.675)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7FDFFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.095,
  stopColor: "#74BAE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.198,
  stopColor: "#6A9AD7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3098,
  stopColor: "#617FC9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4318,
  stopColor: "#5B6BBD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5688,
  stopColor: "#565CB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7335,
  stopColor: "#5454B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5351AF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_233_16300",
  x1: 261.001,
  y1: 250.438,
  x2: 216.457,
  y2: 320.832,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C0BFF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2938,
  stopColor: "#C5C4F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6399,
  stopColor: "#D3D2F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9E9FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_233_16300",
  x1: 367.394,
  y1: 123.411,
  x2: 246.563,
  y2: 332.884,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C0BFF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1172,
  stopColor: "#D0CFF9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2627,
  stopColor: "#E9E9FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5143,
  stopColor: "#C0BFF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6217,
  stopColor: "#D0CFF9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.755,
  stopColor: "#E9E9FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C0BFF6"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_233_16300",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(428.084 221.11) rotate(-120.583) scale(246.782 246.782)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7FDFFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.095,
  stopColor: "#74BAE9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.198,
  stopColor: "#6A9AD7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3098,
  stopColor: "#617FC9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4318,
  stopColor: "#5B6BBD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5688,
  stopColor: "#565CB5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7335,
  stopColor: "#5454B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5351AF"
})));

function SvgOnboardingPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 443,
    viewBox: "0 0 608 443",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingPayment);
export default __webpack_public_path__ + "static/media/onboarding-payment.df9eb6c7.svg";
export { ForwardRef as ReactComponent };